// CollectionsData.js
import axios from 'axios';

const COLLECTIONS_ENDPOINT = '/collections.json';
const PRODUCTS_COUNT_KEY = 'products_count';
const HANDLE_KEY = 'handle';
const ID_KEY = 'id';
const TITLE_KEY = 'title';
const DESCRIPTION_KEY = 'description';
const COLLECTIONS_DATA_KEY = 'collections';

const getCollectionsData = async (baseUrl) => {
    const collections = [];
    let page = 1;
    let hasNextPage = true;

    while (hasNextPage) {
        try {
            const url = `${baseUrl}${COLLECTIONS_ENDPOINT}?page=${page}`;
            const response = await axios.get(url);
            const {
                data
            } = response;

            if (data && data[COLLECTIONS_DATA_KEY] && data[COLLECTIONS_DATA_KEY].length > 0) {
                data[COLLECTIONS_DATA_KEY].forEach(collection => {
                    collections.push({
                        id: collection[ID_KEY],
                        title: collection[TITLE_KEY],
                        description: collection[DESCRIPTION_KEY] || '', // Ensure description exists
                        total: collection[PRODUCTS_COUNT_KEY],
                        link: `${baseUrl}/collections/${collection[HANDLE_KEY]}`,
                        handle: collection[HANDLE_KEY], // Add the handle here
                    });
                });
                page++;
            } else {
                hasNextPage = false;
            }
        } catch (error) {
            console.error('Error fetching collections data:', error);
            hasNextPage = false; // Stop fetching on error
            // Consider throwing the error here if you want the calling function to handle it
            // throw error;
        }
    }

    return collections;
};

export {
    getCollectionsData
};